/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/operationResultsMappers";
import * as Parameters from "../models/parameters";
/** Class representing a OperationResults. */
var OperationResults = /** @class */function () {
  /**
   * Create a OperationResults.
   * @param {LabServicesClientContext} client Reference to the service client.
   */
  function OperationResults(client) {
    this.client = client;
  }
  OperationResults.prototype.get = function (operationResultId, options, callback) {
    return this.client.sendOperationRequest({
      operationResultId: operationResultId,
      options: options
    }, getOperationSpec, callback);
  };
  return OperationResults;
}();
export { OperationResults };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var getOperationSpec = {
  httpMethod: "GET",
  path: "subscriptions/{subscriptionId}/providers/Microsoft.LabServices/operationResults/{operationResultId}",
  urlParameters: [Parameters.subscriptionId, Parameters.operationResultId],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {
      bodyMapper: Mappers.OperationResult
    },
    204: {},
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};